import { storage2 } from "./controller";

class uploadView {
  _body = document.querySelector("body");
  _main = document.querySelector("main");
  _search = document.querySelector(".search");
  _modal = document.querySelector(".modal-dialog");
  _form = document.querySelector("#form");
  _blog = document.querySelector(".blog");
  _intro = document.querySelector(".intro_blog");

  _hideMain() {
    this._main.style.display = "none";
  }
  _showMain() {
    this._main.style.display = "flex";
  }

  _overlayMarkup() {
    const markUp = `
    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      
    >
      <div class="modal-dialog modal-dialog-centered " role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Upload Blog</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">To access this page please log in as an admin</div>
          <div class="modal-body">  <input type="email" name="" id="email" placeholder="Your Email..."></div>
          <div class="modal-body">   <input type="password" name="" id="pass" placeholder="Enter Password..." /></div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button type="button" class="btn btn-primary" >Submit</button>
          </div>
        </div>
      </div>
    </div>

    `;
    return markUp;
  }
  _addHandlerPass(verifyPass) {
    this._body.addEventListener("click", function (e) {
      const target = e.target.closest("#submit");
      if (target) {
        e.preventDefault();
        const pass = document.querySelector("#password").value;
        const email = document.querySelector("#email").value;
        verifyPass(pass, email);
      }
    });
  }
  _uploadMarkUp() {
    const markUp = `
   
    <form id="form" class="w-6/12 sm:w-9/12 2sm:w-8/12 md:w-7/12 mx-auto relative top-[-40px] upload_blog">

    <h1 class="text-center font-[600] text-3xl">Upload Blog</h1>
    
  <label class="mt-6 block mb-2 text-base font-[600] text-gray-900 dark:text-white sm:text-sm text-base" for="user_avatar">Upload file</label>
  <input class=" block w-full   text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 sm:text-xs text-sm" aria-describedby="user_avatar_help" id="user_avatar" type="file" name="image">
  
    <div class="mb-6">
      <label for="text" class="block mt-6 mb-6  font-[600] text-gray-900 dark:text-white sm:text-sm text-base">Blog Title</label>
      <input type="text" name="title" id="text" class="shadow-sm p-3 bg-gray-50 border border-gray-300 text-gray-900  rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light sm:text-xs text-sm" placeholder="Start Typing..." required>
    </div>
  
    <label for="message" class="block mb-6  font-[600] text-gray-900 dark:text-white sm:text-sm text-base">Blog Text</label>
    <textarea id="message" name="text" rows="10" class="block p-2.5 w-full  text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 sm:text-xs text-sm" placeholder="Start Typing..."></textarea>
    
  
    <button type="submit" id="submit_upload" class="mt-6 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg  w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 sm:text-sm text-base">Upload Blog</button>
  
    
  
  </form>
  
    `;
    return markUp;
  }
  _addHandlerSubmit(uploadPost, id2) {
    this._main.addEventListener(
      "click",
      function (e) {
        const target = e.target.closest("#submit_upload");
        if (!target) return;

        const form = document.querySelector("#form");

        if (target) {
          e.preventDefault();
          const picture = document.querySelector("#user_avatar").files[0];

          const data = new FormData(form);

          const values = [...data.entries()];

          const obj = {
            [values[1][0]]: values[1][1],
            [values[2][0]]: values[2][1],
            commentData: [""],
          };

          const id = values[1][1];

          if (obj.title === "" && obj.text === "") {
            return;
          } else {
            target.textContent = "Uploading...";
            uploadPost(obj, picture, id);
          }
        }
      },
      true
    );
  }

  _renderUpload() {
    const markUp = this._uploadMarkUp();
    this._blog.innerHTML = "";
    this._intro.innerHTML = "";
    this._blog.insertAdjacentHTML("afterbegin", markUp);
  }
}

export default new uploadView();
